import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { MembershipStatus } from './MembershipStatus';

import {
  getMyHubsGoldenCard,
  getMyHubsSummary,
  getMyHubsVip
} from './Portfolio.actions';
import { WalletSummary } from './WalletSummary';
import { SubscriptionSummary } from './Subscriptions/SubscriptionSummary';
import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import {
  MY_HUBS,
  MY_HUBS_SUBCRRIPTION,
  MY_HUBS_MEMBERSHIP,
  MY_HUBS_SUBCRRIPTION_BUNDLE,
  MY_HUBS_SUPER_SALES,
  MY_HUBS_VIP
} from '../../routes/routes';

import { TravelSummary } from './TravelSummary';
import { SuperSalesSummary } from './SuperSales/SuperSalesSummary';
import { SubscriptionsBundleSummary } from './SubscriptionsBundle/SubscriptionsBundleSummary';
import { VipSummary } from './Vip/VipSummary';

export const Portfolio = () => {
  const dispatch = useAppDispatch();

  const { loading, loadingHubs, walletSummary, vip, goldenCard } =
    useAppSelector((state) => state.portfolio);

  const location = useLocation();
  const history = useHistory();

  const wide = window.innerWidth > 800;

  useEffect(() => {
    if (walletSummary !== null) return;
    dispatch(getMyHubsSummary());
    dispatch(getMyHubsVip());
    dispatch(getMyHubsGoldenCard());
  }, [dispatch]);

  const pathname = location.pathname;

  if (loading) return <Spinner fullScreen={true} />;

  const showTabs = () => {
    return MY_HUBS_MEMBERSHIP;
  };

  return (
    <AnimatedDashboard zoom>
      <WalletSummary />
      <MembershipStatus />

      <Flexed mb='20' column={!wide}>
        <Tabs>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_MEMBERSHIP)}
            selected={pathname === MY_HUBS_MEMBERSHIP}>
            <div>Travel Membership</div>
          </TabSelectButton>
        </Tabs>
        <Tabs>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_SUBCRRIPTION)}
            selected={pathname === MY_HUBS_SUBCRRIPTION}>
            <div>Travel Subscription</div>
          </TabSelectButton>
        </Tabs>

        <Tabs>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_SUBCRRIPTION_BUNDLE)}
            selected={pathname === MY_HUBS_SUBCRRIPTION_BUNDLE}>
            <div>Travel Bundle Subscription</div>
          </TabSelectButton>
        </Tabs>

        <Tabs>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_SUPER_SALES)}
            selected={pathname === MY_HUBS_SUPER_SALES}>
            <div>Super Sales License</div>
          </TabSelectButton>
        </Tabs>
        {(goldenCard?.orders?.length > 0 || vip?.orders?.length > 0) && (
          <Tabs>
            <TabSelectButton
              onClick={() => history.push(MY_HUBS_VIP)}
              selected={pathname === MY_HUBS_VIP}>
              <div>VIP</div>
            </TabSelectButton>
          </Tabs>
        )}
      </Flexed>

      {loadingHubs && <Spinner fullScreen={true} transparent />}

      <Switch location={location} key={location.pathname}>
        <Redirect exact from={MY_HUBS} to={showTabs()} />
        <Route path={MY_HUBS_MEMBERSHIP}>
          <TravelSummary />
        </Route>

        <Route path={MY_HUBS_SUBCRRIPTION}>
          <SubscriptionSummary />
        </Route>

        <Route path={MY_HUBS_SUBCRRIPTION_BUNDLE}>
          <SubscriptionsBundleSummary />
        </Route>

        <Route path={MY_HUBS_SUPER_SALES}>
          <SuperSalesSummary />
        </Route>

        <Route path={MY_HUBS_VIP}>
          <VipSummary />
        </Route>
      </Switch>
    </AnimatedDashboard>
  );
};
